/**
 * GraphQL schema definition used to support bulk write in ApolloWrappers::writeFragmentsToCache.
 * This is merged with ClientSchemaDef when creating the Apollo Client.
 *
 * Schema definitions are composable.
 * To convert a schema definition into a schema, use `buildAstFromSchema`.
 */

import getAllNodeNamesInSchema from 'graphql-client/schema/util/getAllNodeNamesInSchema';

// _AllNodesUnion is e.g. UserNode | TenantNode | TeamNode | ...
const allNodesUnionDef = getAllNodeNamesInSchema()
  .filter((name) => name !== 'Query')
  .join(' | ');

const GraphQLAllNodesSchemaDef = `
   union _AllNodesUnion = ${allNodesUnionDef}
   extend type Query { _allNodes: [_AllNodesUnion!]! }
 `;
export default GraphQLAllNodesSchemaDef;
